const env = {
    production: true,
    env: 'qa',
    ROOT_URL: 'https://qa-kaskade.nonprod.k8s.eon.com',
    API_URL: '/api',
    ASSET_URL: '/assets',
    envModules: [],
    oauth: {
        redirectUrl: window.location.origin + window.location.pathname,
        loginUrl: 'https://westnetz-tnb-portal-stg.eon-ciam-dev.auth0app.com/authorize' +
            '?response_type=code' +
            '&client_id=DTsSk2CdhMbFIyxmWiOpQCaLGXxPraTq' +
            '&scope=offline_access' +
            '&audience=urn:westnetz:tnbportal:kaskade:backend:stg' +
            '&redirect_uri=https://qa-kaskade.nonprod.k8s.eon.com',
        logoutUrl: 'https://westnetz-tnb-portal-stg.eon-ciam-dev.auth0app.com/v2/logout' +
            '?client_id=DTsSk2CdhMbFIyxmWiOpQCaLGXxPraTq' +
            '&returnTo=https://qa-kaskade.nonprod.k8s.eon.com',
    },
};

export const environment = env;
